<template>
	<transition name="modal" appear>
		<div class="modal">
			<a class="overlay" @click="close"/>
			<div class="box">
				<a class="close" @click="close" v-html="require('@/assets/icons/times-regular.svg')"/>
				<div class="content">
					<div class="title">
						<slot name="title"/>
					</div>
					<div class="text">
						<slot name="text"/>
					</div>
					<slot/>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	methods: {
		close() {
			this.$emit("close");
		}
	}
};
</script>

<style  lang="scss" scoped>
.modal {
	position: fixed;
	left: 0;
	bottom: 0;
	right: 0;
	top: 0;
	color: $black1;
	display: flex;
	align-items: center;
	justify-content: center;

	&-enter-active, &-leave-active {
		transition: cubic(opacity);
	}

	&-enter, &-leave-to {
		opacity: 0;
	}

	@include res(xsmall) {
		align-items: flex-start;
	}

	.overlay {
		background-color: transparentize($black1, 0.5);
		position: fixed;
		left: 0;
		bottom: 0;
		right: 0;
		top: 0;
	}

	.box {
		height: 80vh;
		min-height: 20em;
		position: relative;
		background-color: $white1;
		width: 930px;
		max-width: 100%;
		display: flex;
		flex-direction: column;

		@include res(xsmall) {
			max-height: 100vh;
			min-height: auto;
			height: auto;
			padding: 1em;

		}

		.close {
			position: absolute;
			top: 0;
			right: 0;
			padding: 1em;

			/deep/ svg {
				$s: 15px;
				width: $s;
				height: $s;
			}
		}

		.content {
			display: flex;
			flex-direction: column;
			height: 100%;

			.title {
				font-family: $fontMinion;
				font-size: 28px;
				font-weight: 700;
				margin-bottom: 1.2em;
			}
			.text {
				overflow: auto;
				color: #363B40;
				line-height: 24px;
			}
		}
	}
}
</style>
